export const SET_SUMMARY = "adminOrder/SET_SUMMARY";
export const SET_ORDERS = "adminOrder/SET_ORDERS";
export const SET_FILTERS = "adminOrder/SET_FILTERS";
export const SET_ORDER = "adminOrder/SET_ORDER";
